import { render, staticRenderFns } from "./CashierSystem.vue?vue&type=template&id=2af85adb&scoped=true"
import script from "./CashierSystem.vue?vue&type=script&lang=js"
export * from "./CashierSystem.vue?vue&type=script&lang=js"
import style0 from "./CashierSystem.vue?vue&type=style&index=0&id=2af85adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af85adb",
  null
  
)

export default component.exports